<template>
  <div>
    <b-card
      no-body
      class="mb-0 p-3"
    >
      <b-card-body>
        <b-card-title>
          <feather-icon
            icon="FileMinusIcon"
            size="30"
            class="mr-0 mr-sm-50"
          /> Solicitud para Baja: Temporal, Definitiva
        </b-card-title>

        <b-row class="mt-5">
          <b-col md="12">
            <b-card
              bg-variant="light"
              no-body
            >
              <b-card-body>
                <p><b>1) Seleccione al alumno:</b></p>
                <selectmatricula
                  @matricula="personaobj=$event"
                />
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-card
              bg-variant="light"
              no-body
            >
              <b-card-body>
                <p><b>2) Seleccione el posgrado.</b></p>
                <selectespecialidades
                  class="py-2"
                  :esp.sync="espobj"
                  :mat.sync="personaobj.matricula"
                  @tipoEsp="espobj=$event"
                  @catalogotiposEsp="cdesp=$event"
                />
                <p><small>* Solo se muestran los posgrados a las que el alumno está inscrito y activo.</small></p>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="aCAselectBaja">
          <b-col md="12">
            <b-card
              bg-variant="light"
              no-body
            >
              <b-card-body>
                <p><b>3) Seleccione el tipo de baja que desea solicitar.</b></p>
                <component
                  :is="aCAselectBaja"
                  ref="selectBaja"
                  :baja.sync="bajaobj"
                  :tipos="bajaOptions"
                  @tipoBaja="bajaobj=$event"
                />
                <p> <small> * Al solicitar su BAJA TEMPORAL, conforme al artículo 40 del Reglamento Escolar, el alumno interrumpirá sus estudios en el presente Ciclo Escolar (periodo) y no generará calificación en kárdex. Así mismo, la solicitud ingresada solo le permitirá ausentarse durante un periodo, reintegrándole a sus estudios automáticamente en el siguiente periodo inmediato.</small></p>
                <p> <small> * Al solicitar su BAJA DEFINITIVA, conforme al artículo 40 del Reglamento Escolar, el alumno ha decidido abandonar sus estudios de manera permanente, sin responsabilidad de ningún tipo para INDETEC y sin derecho a solicitar reembolso alguno.</small></p>

              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <div ref="sagenda">
          <b-row
            v-if="aCAselectPeriodoAgenda"
          >
            <b-col md="12">
              <b-card
                bg-variant="light"
                no-body
              >
                <b-card-body>
                  <p><b>3) Seleccione el periodo disponible que desea dar de baja: </b></p>
                  <component
                    :is="aCAselectPeriodoAgenda"
                    ref="selectPeriodoAgenda"
                    :agd.sync="agdobj"
                    :esp.sync="espobj"
                    :mat.sync="personaobj.matricula"
                    @tipoAgd="agdobj=$event"
                    @catalogotiposAgd="cdagd=$event"
                  />
                  <p><small>*Solo se muestra el periodo en el que su agenda se encuentra activa, si no visualiza el periodo, significa que, o aún no es el tiempo de solicitar la baja, o venció el plazo para solicitarla. Le sugerimos verificar ésta información en el Cronograma de Actividades que le corresponda. Si persisten dudas, contácte el área de soporte.</small></p>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>

        <!-- archivo -->
        <div v-if="bajaobj !== null && espobj !== null">
          <div v-if="bajaobj.id === 2 || bajaobj.id === 1">
            <b-row>
              <b-col md="12">
                <b-form
                  class="p-2 needs-validation"
                  novalidate
                  @submit.prevent
                >
                  <!-- Upload file -->
                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        :label="'Seleccione la solicitud de baja '+((storedFiles.length > 0) ? ' Actualizada' : '')"
                        label-for="invoice-balance"
                      >
                        <b-form-file
                          v-model="fileToUpload"
                          placeholder="Escoge un archivo"
                          size="sm"
                          :state="Boolean(fileToUpload)"
                          accept=".pdf"
                        >
                          <template
                            slot="file-name"
                            slot-scope="{ names }"
                          >
                            <b-badge variant="primary">
                              {{ names[0] }}
                            </b-badge>
                            <b-badge
                              v-if="names.length > 1"
                              variant="dark"
                              class="ml-1"
                            >
                              + {{ names.length - 1 }} More files
                            </b-badge>
                          </template>
                        </b-form-file>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>

              </b-col>
              <!-- botones de subir archivo -->
            </b-row>
            <b-row>
              <b-col md="12">
                <!-- btn upload -->
                <b-form-group>
                  <div class="text-center">
                    <b-link
                      to="/servicio-escolar/dashboard"
                    >
                      <b-button
                        v-show="checkProcess.storagefile== false"
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="outline-warning"
                        class="mr-2"
                        size="sm"
                      >
                        Salir
                      </b-button>
                    </b-link>
                    <b-button
                      v-show="checkProcess.storagefile== false"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-primary"
                      size="sm"
                      @click="verificar(agdobj, 2)"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        class="mr-50"
                      />
                      <b-spinner
                        v-show="loader.upload"
                        variant="success"
                        class="mr-1"
                        small
                      />
                      {{ (loader.upload) ? 'Trabajando...': 'Enviar solicitud' }}
                    </b-button>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormFile,
  BSpinner,
  BBadge,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BLink,
} from 'bootstrap-vue'
import store from '@/store'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import {
  ref, computed, onMounted, watch, getCurrentInstance,
} from '@vue/composition-api'
import { assignAsPersonalDocument } from '@/views/components/documentacion/useDocumentacion'
import selectespecialidades from '@/views/components/selects/select-especialidad-activa.vue'
import { useBajasCatalogos } from '@/views/campus/alumno/components/baja/useBaja'
import selectmatricula from '@/views/components/selects/select-matricula.vue'

const selectPeriodoAgenda = () => import('@/views/components/selects/select-periodos-agendas.vue')
const selectBaja = () => import('@/views/campus/alumno/components/baja/componentes/select-tipos-baja.vue')

export default {
  components: {
    BForm,
    BCard,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormFile,
    BSpinner,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    selectespecialidades,
    selectBaja,
    selectPeriodoAgenda,
    selectmatricula,
    BLink,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy
    const aCAselectPeriodoAgenda = ref(null)
    const aCAselectBaja = ref(null)
    const cdesp = null
    const espobj = ref(null)
    const personaobj = ref({ matricula: null, per: null })
    const cdagd = null
    const agdobj = ref(null)
    const bajaobj = ref(null)
    const toast = useToast()
    const tiposol = ref(null)
    const checkProcess = ref({
      storagefile: false,
    })
    const fileToUpload = ref(null)
    const userRole = computed(() => store.state.cuenta.rolSelected)
    const storedFiles = ref([])
    // Computed propieties
    const loader = ref({
      upload: false, fetchData: false,
    })
    const {
      bajaOptions, bajaOptionsPromise,
    } = useBajasCatalogos()
    const fetchCatalogos = () => {
      Promise.all([bajaOptionsPromise])
        .then(() => { })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {})
    }
    const uploadconfig = computed(() => {
      const directorio = `alumnos/${personaobj.value.per}/documentos/solicitud_baja`

      const dataReturn = {
        ref: `/${directorio}`, cat: '9', repo: 0, struct: '3',
      }
      return dataReturn
    })

    const saveChanges = (idFile, agenda) => {
      if (idFile !== null) {
        const datasent = {
          periodo: agenda.periodo,
          id_agenda: agenda.id_agenda,
          archivo_lk: idFile,
          tipo_baja: bajaobj.value.nombre,
          tipo_solicitante: userRole.value.id,
        }
        store.dispatch('bajas/postDatosSol', { data: datasent })
          .then(response => {
            vm.$swal({
              icon: 'success',
              allowOutsideClick: false,
              title: 'Solicitud creada',
              html: `${response.message}`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            emit('reload-data')
          }, error => {
            vm.$swal({
              icon: 'error',
              allowOutsideClick: false,
              title: 'Lo sentimos - error de servicio',
              html: `${error}`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          })
      }
    }
    const uploadfile = agenda => {
      if (bajaobj.value.id !== null && agenda !== null && bajaobj.value !== null && userRole.value !== null) {
        if (fileToUpload.value !== null) {
          loader.value.upload = true
          uploadconfig.value.file = fileToUpload.value
          if (uploadconfig.value.file.type === 'application/pdf') {
            store.dispatch('cuenta/handleFile', uploadconfig.value)
              .then(response => {
                const [dlvryResponse] = response.data.ids
                if (response.data.msg === 'OK') {
                  assignAsPersonalDocument({
                    task: 'wsdocumentos', action: 2, token: store.state.cuenta.session.token, p: personaobj.value.per, f: dlvryResponse.id, td: 12,
                  })
                    .then(result => {
                      loader.value.upload = false
                      if (result.status === 200) {
                        fileToUpload.value = null
                        saveChanges(dlvryResponse.id, agenda)
                      }
                    }, error => {
                      loader.value.upload = false
                      toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Error al asignar documento',
                          text: error,
                          icon: 'AlertCircleIcon',
                          variant: 'danger',
                        },
                      },
                      { timeout: 10000 })
                    })
                } else {
                  loader.value.upload = false
                  toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Seleccione el archivo nuevamente',
                      text: response.data.msg,
                      icon: response.icon,
                      variant: response.label,
                    },
                  },
                  { timeout: 10000 })
                }
              }, error => {
                loader.value.upload = false
                toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Atención',
                    text: error,
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                  },
                },
                { timeout: 10000 })
              })
          } else {
            loader.value.upload = false
            toast({
              component: ToastificationContent,
              props: {
                title: 'Atención',
                text: 'Solo se aceptan archivos PDF',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
          }
        } else {
          loader.value.upload = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Falta archivo',
              text: 'Verifique que haya adjuntado un archivo PDF',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 3000 })
        }
      } else {
        loader.value.upload = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención servicio no habilitado',
            text: 'Verifique que haya seleccionado la agenda',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 8000 })
      }
    }
    const downloadFile = file => {
      window.open(`${process.env.VUE_APP_DELIVERY_DOWNLOAD}${file.rutaDoc}${file.extBase}`, '_blank')
    }
    const goto = refName => {
      const elemento = vm.$refs[refName]
      const top = elemento.offsetTop
      window.scrollTo({
        top: top - 240,
        left: 100,
        behavior: 'smooth',
      })
    }
    const verificarDef = () => {
      store.dispatch('bajas/fetchultimaagenda', { data: personaobj.value.matricula, plan: espobj.value.id })
        .then(response => {
          const ultimaagenda = response
          if (ultimaagenda.length > 0) {
            store.dispatch('bajas/fetchsolicitudactiva', { data: ultimaagenda[0].id_agenda })
              .then(responses => {
                if (responses === true) uploadfile(ultimaagenda[0])
                else {
                  vm.$swal({
                    icon: 'warning',
                    allowOutsideClick: false,
                    title: 'Lo sentimos',
                    html: `Usted ya cuenta con una solicitud para el periodo: ${ultimaagenda[0].clave}.`,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
              .catch(errors => {
                vm.$swal({
                  icon: 'warning',
                  allowOutsideClick: false,
                  title: 'Lo sentimos',
                  html: `Por el momento no esta disponible el servicio ( ${errors} )`,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              })
          } else {
            vm.$swal({
              icon: 'warning',
              allowOutsideClick: false,
              title: 'Lo sentimos',
              html: 'Lo sentimos, contacte a control escolar, su status no permite la Baja Definitiva.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        }).catch(error => {
          vm.$swal({
            icon: 'warning',
            allowOutsideClick: false,
            title: 'Lo sentimos',
            html: `Por el momento no esta disponible el servicio ( ${error} )`,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        })
    }
    const verificar = (agenda, tipo) => {
      if (bajaobj.value.id === 2) {
        if (agenda) {
          const promesa2 = new Promise((resolve, reject) => {
            store.dispatch('bajas/fetchsolicitudactiva', { data: agenda.id_agenda })
              .then(response => { resolve(response) }).catch(error => { reject(error) })
          })

          Promise.all([promesa2]).then(valores => {
            const [sactiva] = valores
            if (sactiva === true) {
              if (tipo === 2) {
                uploadfile(agenda)
              }
            } else {
              let mensaje = ''
              if (sactiva === false) mensaje = ` ${mensaje} Este alumno ya cuenta con una solicitud para el periodo: ${agenda.clave}.`
              if (sactiva === null) mensaje = 'Error: servicio no disponible'
              vm.$swal({
                icon: 'warning',
                allowOutsideClick: false,
                title: 'Lo sentimos',
                html: `${mensaje}`,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            }
          })
            .catch(error => {
              vm.$swal({
                icon: 'warning',
                allowOutsideClick: false,
                title: 'Lo sentimos',
                html: `Por el momento no esta disponible el servicio ( ${error} )`,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        } else {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Atención',
              text: 'Selecciona un periodo',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 2000 })
        }
      } else if (bajaobj.value.id === 1) {
        verificarDef()
      }
    }
    watch(() => bajaobj.value, valor => {
      aCAselectPeriodoAgenda.value = null
      agdobj.value = null
      if (valor !== null) {
        aCAselectPeriodoAgenda.value = valor.id === 2 ? 'selectPeriodoAgenda' : null
        if (valor.id === 2) goto('sagenda')
      }
    })
    watch(() => agdobj.value, valor => {
      if (valor !== null && bajaobj !== null) {
        verificar(valor, 1)
      }
    })
    watch(() => espobj.value, valor => {
      if (valor !== null) {
        aCAselectBaja.value = 'selectBaja'
      } else {
        aCAselectBaja.value = null
        bajaobj.value = null
        agdobj.value = null
      }
    })
    onMounted(() => {
      if (userRole.value.id === 2 || userRole.value.id === 11) fetchCatalogos()
      else {
        vm.$swal({
          icon: 'warning',
          allowOutsideClick: false,
          title: 'Lo sentimos',
          html: `Su rol <b>${userRole.value.nombre}</b> No tiene permisos para crear solicitud de baja - Contacte a sistemas`,
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    })

    return {
      userRole,
      useBajasCatalogos,
      // fuctions
      uploadfile,
      bajaOptions,
      downloadFile,
      // values
      fileToUpload,
      storedFiles,
      // flags
      checkProcess,
      loader,
      cdesp,
      espobj,
      personaobj,
      bajaobj,
      cdagd,
      agdobj,
      aCAselectPeriodoAgenda,
      aCAselectBaja,
      tiposol,
      verificar,
    }
  },
}
</script>
<style lang="scss">
.custom-file-input:lang(es) ~ .custom-file-label::after {
  content: 'Buscar';
}
</style>
